"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.object.seal");
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.replace");
var _editorForVue = require("@wangeditor/editor-for-vue");
var _dayjs = _interopRequireDefault(require("dayjs"));
var _ossUpload = require("@/utils/ossUpload");
var _copyText = require("@/utils/copyText");
var _member = require("@/api/member/member");
var _activity = require("@/api/marketingFunction/superSubsidyV2/activity");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 用户类型：1 新用户、2 所有人、3 已提现用户、4 指定等级
var USER_TYPE_GRADE = 4;

// 活动列表查询条件
function createQueryData() {
  return {
    name: '',
    status: null,
    page: 1,
    size: 20
  };
}

// 活动表单字段初始值；新增、重置、关闭均取新对象，避免共享引用
function createRuleForm() {
  return {
    id: null,
    name: '',
    headPic: '',
    userType: null,
    userGrade: null,
    // 背景色默认 #F8F8F8，与后端留空默认值一致（拾色器/输入框同步显示）
    bgColor: '#F8F8F8',
    ruleTxt: '',
    status: null,
    timeArray: []
  };
}
var _default = exports.default = {
  name: 'SuperSubsidyV2Activity',
  components: {
    Editor: _editorForVue.Editor,
    Toolbar: _editorForVue.Toolbar
  },
  data: function data() {
    var _this = this;
    var validateRuleTxt = function validateRuleTxt(rule, value, callback) {
      // 富文本空内容为 <p><br></p>，去除标签后无文案视为未填写
      var text = (value || '').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').trim();
      if (!text) {
        callback(new Error('请输入活动规则文案'));
        return;
      }
      callback();
    };
    var validateUserGrade = function validateUserGrade(rule, value, callback) {
      if (_this.ruleForm.userType === USER_TYPE_GRADE && (value === null || value === undefined || value === '')) {
        callback(new Error('请选择指定等级'));
        return;
      }
      callback();
    };
    return {
      // 活动时间快捷选项：长期有效（距今一年）
      pickerOptions: {
        shortcuts: [{
          text: '长期有效',
          onClick: function onClick(picker) {
            picker.$emit('pick', [(0, _dayjs.default)().startOf('day').toDate(), (0, _dayjs.default)().add(365, 'day').endOf('day').toDate()]);
          }
        }]
      },
      queryData: createQueryData(),
      total: 0,
      tableData: [],
      tableLoading: false,
      listSeq: 0,
      // 列表取数序号：仅最新一次请求可写入表格，丢弃过期响应
      saveLoading: false,
      deleting: false,
      gradeOption: [],
      eventsType: 'add',
      // add 新增 / edit 编辑
      dialogVisible: false,
      ruleForm: createRuleForm(),
      rules: {
        name: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }],
        headPic: [{
          required: true,
          message: '请上传头图',
          trigger: 'change'
        }],
        userType: [{
          required: true,
          message: '请选择用户类型',
          trigger: 'change'
        }],
        userGrade: [{
          validator: validateUserGrade,
          trigger: 'change'
        }],
        timeArray: [{
          required: true,
          message: '请选择活动时间',
          trigger: 'change'
        }],
        // required 用于展示必填星号，空值判断由 validateRuleTxt 处理（富文本空内容为 <p><br></p>）
        ruleTxt: [{
          required: true,
          validator: validateRuleTxt,
          trigger: 'change'
        }]
      },
      editor: null,
      toolbarConfig: {},
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            // 富文本内图片上传：走 OSS 直传，成功后插入图片地址
            customUpload: function () {
              var _customUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(file, insertFn) {
                var pictureUrl, _t;
                return (0, _regenerator2.default)().w(function (_context) {
                  while (1) switch (_context.p = _context.n) {
                    case 0:
                      _context.p = 0;
                      _context.n = 1;
                      return (0, _ossUpload.uploadOSS)(file);
                    case 1:
                      pictureUrl = _context.v;
                      insertFn(pictureUrl);
                      _context.n = 3;
                      break;
                    case 2:
                      _context.p = 2;
                      _t = _context.v;
                      console.log(_t);
                    case 3:
                      return _context.a(2);
                  }
                }, _callee, null, [[0, 2]]);
              }));
              function customUpload(_x, _x2) {
                return _customUpload.apply(this, arguments);
              }
              return customUpload;
            }()
          }
        }
      },
      mode: 'default' // or 'simple'
    };
  },
  computed: {
    // 进行中、已结束的活动用户类型不可修改，未开始可改
    userTypeDisabled: function userTypeDisabled() {
      return this.eventsType === 'edit' && (this.ruleForm.status === 1 || this.ruleForm.status === 2);
    }
  },
  created: function created() {
    this.getActivityList();
    this.getGradeOption();
  },
  beforeDestroy: function beforeDestroy() {
    var editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
  methods: {
    // 租户等级选项，指定等级单选
    getGradeOption: function () {
      var _getGradeOption = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return (0, _member.memberQueryMemberGradeApi)({});
            case 1:
              res = _context2.v;
              this.gradeOption = res.data || [];
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getGradeOption() {
        return _getGradeOption.apply(this, arguments);
      }
      return getGradeOption;
    }(),
    // 活动分页查询
    getActivityList: function () {
      var _getActivityList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var seq, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              seq = ++this.listSeq;
              _context3.p = 1;
              this.tableLoading = true;
              _context3.n = 2;
              return (0, _activity.activityList)((0, _objectSpread2.default)({}, this.queryData));
            case 2:
              res = _context3.v;
              if (!(seq !== this.listSeq)) {
                _context3.n = 3;
                break;
              }
              return _context3.a(2);
            case 3:
              this.tableData = res.data.data || [];
              this.total = res.data.total || 0;
              _context3.n = 5;
              break;
            case 4:
              _context3.p = 4;
              _t3 = _context3.v;
              console.log(_t3);
            case 5:
              _context3.p = 5;
              if (seq === this.listSeq) {
                this.tableLoading = false;
              }
              return _context3.f(5);
            case 6:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 4, 5, 6]]);
      }));
      function getActivityList() {
        return _getActivityList.apply(this, arguments);
      }
      return getActivityList;
    }(),
    // 查询：回到第一页
    onInquire: function onInquire() {
      this.queryData.page = 1;
      this.getActivityList();
    },
    // 重置查询条件并刷新
    onInitialize: function onInitialize() {
      this.queryData = createQueryData();
      this.getActivityList();
    },
    // 每页条数变化
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.size = val;
      this.getActivityList();
    },
    // 页码变化
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page = val;
      this.getActivityList();
    },
    // 切换到非指定等级时清空已选等级
    onUserTypeChange: function onUserTypeChange(value) {
      if (value !== USER_TYPE_GRADE) {
        this.ruleForm.userGrade = null;
      }
    },
    // 新增：按初始值打开弹窗
    onAdd: function onAdd() {
      this.eventsType = 'add';
      this.ruleForm = createRuleForm();
      this.dialogVisible = true;
    },
    // 富文本实例 seal 后交给 v-model 托管，避免深层响应式改写编辑器内部状态
    onCreated: function onCreated(editor) {
      this.editor = Object.seal(editor);
    },
    // 头图上传：OSS 直传后回填地址
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(_ref) {
        var file, pictureUrl, _t4;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              file = _ref.file;
              _context4.p = 1;
              _context4.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context4.v;
              this.ruleForm.headPic = pictureUrl;
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t4 = _context4.v;
              console.log(_t4);
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 3]]);
      }));
      function handleFileUpload(_x3) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    // 先取详情再开弹窗：编辑回填数据未取到时不展示空表单
    onEdit: function () {
      var _onEdit = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5(row) {
        var res, data, _t5;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              _context5.n = 1;
              return (0, _activity.activityDetail)({
                id: row.id
              });
            case 1:
              res = _context5.v;
              data = res.data || {};
              this.eventsType = 'edit';
              // 只取表单字段：详情返回的创建/更新时间等不进入表单模型
              this.ruleForm = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, createRuleForm()), {}, {
                id: data.id,
                name: data.name,
                headPic: data.headPic,
                userType: data.userType,
                userGrade: data.userGrade,
                bgColor: data.bgColor,
                ruleTxt: data.ruleTxt,
                // 进行中、已结束活动的用户类型锁定判断依赖 status
                status: data.status,
                timeArray: data.startTime && data.endTime ? [data.startTime, data.endTime] : []
              });
              this.dialogVisible = true;
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t5 = _context5.v;
              console.log(_t5);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function onEdit(_x4) {
        return _onEdit.apply(this, arguments);
      }
      return onEdit;
    }(),
    // 校验通过后二次确认再提交
    submitForm: function submitForm(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (!valid) return;
        _this2.$confirm("\u662F\u5426\u786E\u8BA4".concat(_this2.eventsType === 'add' ? '添加' : '编辑', "\u6B64\u6D3B\u52A8?"), '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this2.onSave();
        }).catch(function () {});
      });
    },
    // 保存：仅指定等级提交等级值
    onSave: function () {
      var _onSave = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee6() {
        var _this$ruleForm, id, name, headPic, userType, userGrade, bgColor, ruleTxt, timeArray, params, _t6;
        return (0, _regenerator2.default)().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              if (!this.saveLoading) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2);
            case 1:
              this.saveLoading = true;
              _context6.p = 2;
              _this$ruleForm = this.ruleForm, id = _this$ruleForm.id, name = _this$ruleForm.name, headPic = _this$ruleForm.headPic, userType = _this$ruleForm.userType, userGrade = _this$ruleForm.userGrade, bgColor = _this$ruleForm.bgColor, ruleTxt = _this$ruleForm.ruleTxt, timeArray = _this$ruleForm.timeArray;
              params = {
                id: id || undefined,
                name: name,
                headPic: headPic,
                userType: userType,
                userGrade: userType === USER_TYPE_GRADE ? Number(userGrade) : null,
                bgColor: bgColor,
                startTime: timeArray[0],
                endTime: timeArray[1],
                ruleTxt: ruleTxt
              };
              _context6.n = 3;
              return (0, _activity.activitySave)(params);
            case 3:
              this.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });
              this.handleClose();
              this.onInquire();
              _context6.n = 5;
              break;
            case 4:
              _context6.p = 4;
              _t6 = _context6.v;
              console.log(_t6);
            case 5:
              _context6.p = 5;
              this.saveLoading = false;
              return _context6.f(5);
            case 6:
              return _context6.a(2);
          }
        }, _callee6, this, [[2, 4, 5, 6]]);
      }));
      function onSave() {
        return _onSave.apply(this, arguments);
      }
      return onSave;
    }(),
    // 重置为初始值（同时清空校验态）
    resetForm: function resetForm(formName) {
      this.ruleForm = createRuleForm();
      this.$refs[formName] && this.$refs[formName].resetFields();
    },
    // 关闭：重置表单并收起弹窗
    handleClose: function handleClose() {
      this.resetForm('ruleForm');
      this.dialogVisible = false;
    },
    // 删除：确认后提交并刷新（进行中不可删由后端拦截）
    onDelete: function onDelete(row) {
      var _this3 = this;
      if (this.deleting) return;
      this.$confirm('是否确认删除此活动?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee7() {
        var _t7;
        return (0, _regenerator2.default)().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _this3.deleting = true;
              _context7.p = 1;
              _context7.n = 2;
              return (0, _activity.activityDelete)({
                id: row.id
              });
            case 2:
              _this3.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });
              _this3.getActivityList();
              _context7.n = 4;
              break;
            case 3:
              _context7.p = 3;
              _t7 = _context7.v;
              console.log(_t7);
            case 4:
              _context7.p = 4;
              _this3.deleting = false;
              return _context7.f(4);
            case 5:
              return _context7.a(2);
          }
        }, _callee7, null, [[1, 3, 4, 5]]);
      }))).catch(function () {});
    },
    // 复制活动跳转链接；租户未配置活动页模板时接口返回空串
    copyLink: function copyLink(row) {
      if (!row.openUrl) {
        this.$notify.error({
          title: '温馨提示',
          message: '未获取到活动链接，无法复制'
        });
        return;
      }
      (0, _copyText.copyText)(row.openUrl);
    }
  }
};